import React, { Component } from "react";
import {
  Row,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Col,
  FormGroup,
  Table,
  Input,
  CustomInput,
  Button,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { AvForm } from "availity-reactstrap-validation";

import {
  MR_model_open,
  MR_model_close,
  // getMRRowList,
  getMRSelectItem,
  PISelectedItems,
  getMRList,
  SetParams,
} from "../../../store/PurchaseIndent/actions";

class AddMRList extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.toggleTab = this.toggleTab.bind(this);
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 3) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  }
  componentDidMount() {
    this.toggleTab(1);
    // this.props.getMRList();
  }
  getCheckedRequest(e, MRRowdata, mrIndex) {
    if (e.target.checked === true) {
      MRRowdata.mritems.forEach((i, index) => {
        i.qty = i.availableqty;
        this.props.PISelectedItems(true, i, MRRowdata.id, mrIndex, index, 1);
      });
    } else {
      MRRowdata.mritems.forEach((i, index) => {
        i.qty = i.availableqty;
        this.props.PISelectedItems(false, i, MRRowdata.id, mrIndex, index, 1);
      });
    }
  }
  getAllCheckedRequest(e) {
    this.props.MRlist.map((MRRowdata, key) => {
      this.getCheckedRequest(e, MRRowdata, key);
      return 0;
    });
  }
  getAllCheckedSubItem(e) {
    this.props.MRrowlist.forEach((item, key) => {
      this.props.PISelectedItems(
        e.target.checked,
        item,
        this.props.openMRid,
        this.props.openMRindex,
        key,
        2
      );
    });
  }
  // getCheckedSubItem(e, item, MRid, MrIndex, key) {
  //   this.props.PISelectedItems(e.target.checked, item, MRid, MrIndex, key, 2);
  // }
  autohandleSearch = (e) => {
    if (e.target.value === "") {
      if (this.state.activeTab === 1) {
        this.props.SetParams({
          ...this.props.params,
          search: e.target.value,
          page: 1,
        });
        this.props.getMRList({
          search: e.target.value,
          page: 1,
        });
      }
      if (this.state.activeTab === 2) {
        this.props.SetParams({
          ...this.props.params,
          MrId: this.props.params.MrId,
          search: e.target.value,
          page: 1,
        });
        this.props.getMRRowList({
          MrId: this.props.openMRid,
          Index: this.props.openMRindex,
          search: e.target.value,
          page: 1,
        });
      }
    }
    if (this.state.activeTab === 1) {
      this.props.SetParams({
        ...this.props.params,
        search: e.target.value,
        page: 1,
      });
    } else if (this.state.activeTab === 2) {
      this.props.SetParams({
        ...this.props.params,
        MrId: this.props.params.MrId,
        search: e.target.value,
        page: 1,
      });
    }
  };
  handleSearch = (e) => {
    if (e.key === "Enter") {
      if (this.state.activeTab === 1) {
        this.props.getMRList({
          search: e.target.value,
          page: 1,
        });
      } else if (this.state.activeTab === 2) {
        this.props.getMRRowList({
          MrId: this.props.openMRid,
          Index: this.props.openMRindex,
          search: e.target.value,
          page: 1,
        });
      }
    }
  };

  //>>>>>>>>>>>>>>>>>>>>>>>

  render() {
  
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.MRlistModel}
          // toggle={this.tog_static}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader
            toggle={() => {
              this.props.MR_model_close();
              this.toggleTab(1);
            }}
          >
            Purchase Indent Details
          </ModalHeader>
          <ModalBody>
            <AvForm>
              <Row className="justify-content-center p-0">
                <Col md={12} className="pt-0">
                  <Nav tabs className="nav-tabs-custom pt-0">
                    <NavItem>
                      <NavLink
                        onClick={() => {
                          this.toggleTab(1);
                        }}
                        className={classnames(
                          { active: this.state.activeTab === 1 },
                          "pt-3 font-weight-bold card-title-16"
                        )}
                      >
                        MR List | <span>{this.props.MRlist.length}</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: this.state.activeTab === 2 },
                          "pt-3 font-weight-bold card-title-16"
                        )}
                      >
                        {this.state.activeTab === 2 && <span>MR Items</span>}
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                      <div className="mt-2">
                        <FormGroup className="m-0">
                          <InputGroup>
                            <Input
                              type="text"
                              name="search"
                              className="form-control d-inline-block"
                              placeholder="Search Item"
                              value={this.props.params.search}
                              onChange={(e) => this.autohandleSearch(e)}
                              onKeyDown={(e) => this.handleSearch(e)}
                            />
                            <InputGroupAddon addonType="append">
                              {this.props.params.search !== "" && (
                                <Button
                                  // outline
                                  color="light"
                                  type="button"
                                  // className="mr-1"
                                  onClick={() => {
                                    this.props.SetParams({
                                      ...this.props.params,
                                      search: "",
                                      page: 1,
                                    });
                                    this.props.getMRList({
                                      search: "",
                                      page: 1,
                                    });
                                  }}
                                >
                                  <i className="text-danger ri-close-line"></i>
                                </Button>
                              )}

                              <Button
                                color="light"
                                type="button"
                                onClick={() => {
                                  this.props.getMRList({
                                    search: this.props.params.search,
                                    page: 1,
                                  });
                                }}
                              >
                                <i className="ri-search-line"></i> Search
                              </Button>
                            </InputGroupAddon>
                          </InputGroup>
                        </FormGroup>
                      </div>

                      <div className="table-responsive mt-2">
                        <Table className="table-centered mb-0 table-nowrap">
                          <thead className="bg-light text-center ">
                            <tr>
                              <th style={{ width: "20px" }}>
                                <div>
                                  {/* <div className="custom-control custom-checkbox"> */}
                                  <CustomInput
                                    type="checkbox"
                                    name="itemCheckbox"
                                    id="itemCheckbox"
                                    // innerRef={true}
                                    // value={item.itemcheck}
                                    onChange={(e) => {
                                      this.getAllCheckedRequest(e);
                                    }}
                                  />
                                </div>
                              </th>
                              <th>MR No</th>
                              <th>MR Date</th>
                              <th>MR Pending Items</th>
                              <th>Department</th>
                            </tr>
                          </thead>
                          <tbody className="text-center">
                            {this.props.MRlist.map((MRdata, key) => (
                              <tr key={key}>
                                <td>
                                  <div>
                                    {/* <div className="custom-control custom-checkbox"> */}
                                    {MRdata.itemscheck === true && (
                                      <CustomInput
                                        type="checkbox"
                                        name="listItemCheckbox"
                                        id={"itemscheck" + key}
                                        checked={MRdata.itemscheck}
                                        onChange={(e) => {
                                          this.getCheckedRequest(
                                            e,
                                            MRdata,
                                            key
                                          );
                                        }}
                                      />
                                    )}
                                    {MRdata.itemscheck === false && (
                                      <CustomInput
                                        type="checkbox"
                                        name="listItemCheckbox"
                                        id={"itemscheck" + key}
                                        checked={MRdata.itemscheck}
                                        onChange={(e) => {
                                          this.getCheckedRequest(
                                            e,
                                            MRdata,
                                            key
                                          );
                                        }}
                                      />
                                    )}
                                  </div>
                                </td>

                                <td>{MRdata.code}</td>
                                <td>{MRdata.date}</td>
                                <td>
                                  <Link
                                    to="#"
                                    onClick={() => {
                                      this.toggleTab(2);
                                      this.props.SetParams({
                                        ...this.props.params,
                                        MrId: MRdata.id,
                                      });
                                      this.props.getMRRowList({
                                        MrId: MRdata.id,
                                        Index: key,
                                      });
                                    }}
                                    className="text-dark"
                                  >
                                    {MRdata.nonpi_count} ( Items )
                                  </Link>
                                </td>
                                <td>{MRdata.department?.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      <Row>
                        <Col>
                          <div className="float-right">
                            <Button
                              type="button"
                              className="btn btn-danger mr-2"
                              color="light"
                              onClick={() => this.props.MR_model_close()}
                            >
                              Close
                            </Button>
                            <Button
                              type="submit"
                              className="btn btn-primary "
                              color="primary"
                            >
                              Add Data
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId={2}>
                      <div className="mt-2">
                        <FormGroup className="m-0">
                          <InputGroup>
                            <Input
                              type="text"
                              name="search"
                              className="form-control d-inline-block"
                              placeholder="Search Item"
                              value={this.props.params.search}
                              onChange={(e) => this.autohandleSearch(e)}
                              onKeyDown={(e) => this.handleSearch(e)}
                            />
                            <InputGroupAddon addonType="append">
                              {this.props.params.search !== "" && (
                                <Button
                                  // outline
                                  color="light"
                                  type="button"
                                  // className="mr-1"
                                  onClick={() => {
                                    this.props.SetParams({
                                      ...this.props.params,
                                      MrId: this.props.params.MrId,
                                      search: "",
                                      page: 1,
                                    });
                                    this.props.getMRRowList({
                                      MrId: this.props.openMRid,
                                      Index: this.props.openMRindex,
                                      search: "",
                                      page: 1,
                                    });
                                  }}
                                >
                                  <i className="text-danger ri-close-line"></i>
                                </Button>
                              )}

                              <Button
                                color="light"
                                type="button"
                                onClick={() => {
                                  this.props.getMRRowList({
                                    MrId: this.props.openMRid,
                                    Index: this.props.openMRindex,
                                    search: this.props.params.search,
                                    page: 1,
                                  });
                                }}
                              >
                                <i className="ri-search-line"></i> Search
                              </Button>
                            </InputGroupAddon>
                          </InputGroup>
                        </FormGroup>
                      </div>
                      <div className="table-responsive mt-2">
                        <Table className="table-centered mb-0 table-nowrap">
                          <thead className="bg-light text-center">
                            <tr>
                              <th style={{ width: "20px" }}>
                                <div>
                                  <CustomInput
                                    type="checkbox"
                                    name="itemCheckbox"
                                    id="iCheckbox"
                                    // innerRef={true}
                                    // value={item.itemcheck}
                                    onChange={(e) => {
                                      this.getAllCheckedSubItem(e);
                                    }}
                                  />
                                </div>
                              </th>
                              <th style={{ width: "120px" }}>S.No</th>
                              <th style={{ width: "220px" }}>Item Name</th>
                              <th style={{ width: "220px" }}>Quantity</th>
                            </tr>
                          </thead>
                          <tbody className="text-center">
                            {this.props.MRrowlist.map((item, key) => (
                              <tr key={key}>
                                <td className="text-center">
                                  <div>
                                    {" "}
                                    {item.itemcheck + " "}
                                    {item.itemcheck === true && (
                                      <CustomInput
                                        type="checkbox"
                                        name="itemCheckbox"
                                        id={"icheckbox" + item.id}
                                        checked={item.itemcheck}
                                        // onChange={(e) => {
                                        //   this.getCheckedSubItem(
                                        //     e,
                                        //     item,
                                        //     this.props.openMRid,
                                        //     this.props.openMRindex,
                                        //     key
                                        //   );
                                        // }}
                                      />
                                    )}
                                    {item.itemcheck === false && (
                                      <CustomInput
                                        type="checkbox"
                                        name="itemCheckbox"
                                        id={"icheckbox" + item.id}
                                        checked={item.itemcheck}
                                        // onChange={(e) => {
                                        //   this.getCheckedSubItem(
                                        //     e,
                                        //     item,
                                        //     this.props.openMRid,
                                        //     this.props.openMRindex,
                                        //     key
                                        //   );
                                        // }}
                                      />
                                    )}
                                  </div>
                                </td>
                                <td className="text-center">{item.code}</td>
                                <td>
                                  <h5 className="font-size-14 text-truncate">
                                    {item.product.name}
                                  </h5>
                                  <p className="mb-0">
                                    <span className="font-weight-medium">
                                      Make : {item.make}
                                    </span>
                                  </p>
                                </td>

                                <td className="text-center">
                                  {item.qty} {item.unit.name}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      <Row>
                        <Col>
                          <div className="float-right">
                            <Button
                              type="button"
                              className="btn btn-danger"
                              color="light"
                              onClick={() => {
                                this.toggleTab(1);
                              }}
                            >
                              Back
                            </Button>
                            {/* <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  color="primary"
                                >
                                  Load Data
                                </Button> */}
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </AvForm>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  // const { BasicUnitlist } = state.Mini;
  const {
    MRlistModel,
    MRlist,
    MRrowlist,
    PISelectItem,
    openMRid,
    openMRindex,
    params,
  } = state.PurchaseIndent;
  return {
    MRlistModel,
    MRlist,
    MRrowlist,
    PISelectItem,
    openMRid,
    openMRindex,
    params,
  };
};

export default connect(mapStatetoProps, {
  MR_model_open,
  MR_model_close,
  // getMRRowList,
  getMRSelectItem,
  PISelectedItems,
  getMRList,
  SetParams,
})(AddMRList);
